// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { crossbell as _crossbell } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the crossbell chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 3737
 * Chain Name: Crossbell
 * Default Block Explorer: https://scan.crossbell.io
 * Default RPC URL: https://rpc.crossbell.io
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { crossbell } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: crossbell,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const crossbell = createCommon({
	..._crossbell,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
